/**
 * Interruptores de presentación para capacidades que todavía no tienen respaldo
 * real en el PMS. No cambian el servicio seleccionado por VITE_MOCK_*: evitan
 * que se muestre una experiencia incompleta y que se llegue a sus rutas.
 *
 * Una variable ausente equivale a `true`, para conservar el comportamiento de
 * los entornos ya desplegados. Configura `VITE_FEATURE_<NOMBRE>=false` para
 * ocultarla; Vite requiere reiniciar el servidor tras cambiar el .env.
 */
export type FeatureName =
  | 'invitados'
  | 'ayudaPeticiones'
  | 'ayudaFaq'
  | 'ayudaConversacion'
  | 'accesosCodigo'
  | 'accesosPasosFoto'
  | 'accesosDireccionesAvanzadas'
  | 'climaAvisos'
  | 'climaAtajos'
  | 'climaAutomatico'
  | 'climaPrepararLlegada'
  | 'extrasFotos'

const FLAGS: Record<FeatureName, keyof ImportMetaEnv> = {
  invitados: 'VITE_FEATURE_INVITADOS',
  ayudaPeticiones: 'VITE_FEATURE_AYUDA_PETICIONES',
  ayudaFaq: 'VITE_FEATURE_AYUDA_FAQ',
  ayudaConversacion: 'VITE_FEATURE_AYUDA_CONVERSACION',
  accesosCodigo: 'VITE_FEATURE_ACCESOS_CODIGO',
  accesosPasosFoto: 'VITE_FEATURE_ACCESOS_PASOS_FOTO',
  accesosDireccionesAvanzadas: 'VITE_FEATURE_ACCESOS_DIRECCIONES_AVANZADAS',
  climaAvisos: 'VITE_FEATURE_CLIMA_AVISOS',
  climaAtajos: 'VITE_FEATURE_CLIMA_ATAJOS',
  climaAutomatico: 'VITE_FEATURE_CLIMA_AUTOMATICO',
  climaPrepararLlegada: 'VITE_FEATURE_CLIMA_PREPARAR_LLEGADA',
  extrasFotos: 'VITE_FEATURE_EXTRAS_FOTOS',
}

/** Las capacidades están visibles salvo que el entorno las desactive expresamente. */
export function featureEnabled(name: FeatureName): boolean {
  return import.meta.env[FLAGS[name]] !== 'false'
}
